"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FilterSelect = void 0;
var menu_button_1 = require("@reach/menu-button");
require("@reach/menu-button/styles.css");
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var CheckedM_1 = __importDefault(require("../icons/checked/CheckedM"));
var chevron_down_1 = require("../icons/chevron-down");
var mixins_1 = require("../style/mixins");
var theme_1 = require("../style/theme");
var Core_1 = require("./Core");
var Text_1 = __importDefault(require("./Text"));
var FilterSelect = function (props) {
    var emptyLabel = props.emptyLabel, label = props.label, options = props.options, onChange = props.onChange, selected = props.selected;
    var $active = !!selected.length;
    var onItemClick = function (value, isSelected) {
        onChange(isSelected
            ? selected.filter(function (selectedValue) { return selectedValue !== value; })
            : __spreadArray(__spreadArray([], selected, true), [value], false));
    };
    return (react_1.default.createElement(menu_button_1.Menu, null, function (_a) {
        var isExpanded = _a.isExpanded;
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(SelectButton, { "$active": $active, "$isExpanded": isExpanded }, label),
            react_1.default.createElement(menu_button_1.MenuPopover, null,
                react_1.default.createElement(MenuItems, { "$active": $active, "$isExpanded": isExpanded },
                    react_1.default.createElement(Core_1.Flex, { flexDirection: "column", gap: 8, p: "8px 12px" },
                        !options.length && (react_1.default.createElement(Text_1.default, { size: 16, bold: true }, emptyLabel)),
                        options.map(function (_a) {
                            var label = _a.label, value = _a.value;
                            var isSelected = selected.includes(value);
                            return (react_1.default.createElement(MenuItem, { key: value, label: label, onClick: function () { return onItemClick(value, isSelected); }, isSelected: isSelected }));
                        }))))));
    }));
};
exports.FilterSelect = FilterSelect;
var SelectButton = function (_a) {
    var children = _a.children, $active = _a.$active, $isExpanded = _a.$isExpanded;
    return (react_1.default.createElement(MenuButton, { "$active": $active, "$isExpanded": $isExpanded },
        react_1.default.createElement(Core_1.Flex, { gap: 10 },
            react_1.default.createElement(Text_1.default, { size: 18, bold: true }, children),
            react_1.default.createElement(LabelChevron, { "$isExpanded": $isExpanded }))));
};
var backgroundColorMap = {
    Epsy: theme_1.epsyTheme.oldColors.shade[5],
    LivaNova: theme_1.livaNovaTheme.colors.white
};
var borderColorMap = {
    Epsy: "transparent",
    LivaNova: theme_1.livaNovaTheme.oldColors.shade[8]
};
var borderStyle = (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  transition: border-color 0.4s linear;\n\n  border: 2px solid;\n  border-color: ", ";\n\n  &:hover {\n    border-color: ", ";\n  }\n"], ["\n  transition: border-color 0.4s linear;\n\n  border: 2px solid;\n  border-color: ", ";\n\n  &:hover {\n    border-color: ", ";\n  }\n"])), function (_a) {
    var theme = _a.theme, $isExpanded = _a.$isExpanded;
    return $isExpanded ? theme.oldColors.primary.purple : borderColorMap[theme.mode];
}, function (p) { return p.theme.oldColors.primary.purple; });
var colorStyle = (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
    var $active = _a.$active, _b = _a.theme, oldColors = _b.oldColors, mode = _b.mode;
    return (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    color: ", ";\n    background-color: ", ";\n  "], ["\n    color: ", ";\n    background-color: ", ";\n  "])), $active ? oldColors.shade[5] : oldColors.primary.purple, $active
        ? oldColors.primary.purple
        : backgroundColorMap[mode]);
});
var MenuButton = (0, styled_components_1.default)(menu_button_1.MenuButton)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  ", ";\n  ", ";\n  ", ";\n  padding: 4px 8px;\n  border-radius: 6px;\n"], ["\n  ", ";\n  ", ";\n  ", ";\n  padding: 4px 8px;\n  border-radius: 6px;\n"])), mixins_1.normalizeButton, colorStyle, borderStyle);
var LabelChevron = (0, styled_components_1.default)(chevron_down_1.ChevronDownM)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  transform: rotate(", "deg);\n"], ["\n  transform: rotate(", "deg);\n"])), function (p) { return (p.$isExpanded ? "180" : "0"); });
var MenuItems = (0, styled_components_1.default)(menu_button_1.MenuItems)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  &[data-reach-menu-items] {\n    ", ";\n    ", ";\n\n    margin-top: 8px;\n    border-radius: 6px;\n    padding: 0;\n  }\n"], ["\n  &[data-reach-menu-items] {\n    ", ";\n    ", ";\n\n    margin-top: 8px;\n    border-radius: 6px;\n    padding: 0;\n  }\n"])), colorStyle, borderStyle);
var MenuItem = function (_a) {
    var label = _a.label, isSelected = _a.isSelected, onClick = _a.onClick;
    var onClickHandler = function (event) {
        event.preventDefault();
        onClick();
    };
    return (react_1.default.createElement(MenuLink, { "$active": isSelected, onClick: onClickHandler },
        react_1.default.createElement(Core_1.Flex, { width: 1, gap: 8, alignItems: "center", justifyContent: "space-between" },
            react_1.default.createElement(Text_1.default, { size: 18, bold: true }, label),
            react_1.default.createElement(Core_1.Box, { flexShrink: 0, width: 16, height: 16, bg: isSelected ? "currentColor" : "unset", border: "2px solid currentColor", borderRadius: 3 },
                react_1.default.createElement(Core_1.Flex, { alignItems: "center", justifyContent: "center", height: "100%" },
                    react_1.default.createElement(CheckedIcon, { width: 8, height: 8, "$visible": isSelected }))))));
};
var MenuLink = (0, styled_components_1.default)(menu_button_1.MenuLink)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  &[data-reach-menu-item] {\n    padding: 0;\n\n    &[data-selected] {\n      background: transparent;\n      color: inherit;\n      text-decoration: underline;\n    }\n  }\n"], ["\n  &[data-reach-menu-item] {\n    padding: 0;\n\n    &[data-selected] {\n      background: transparent;\n      color: inherit;\n      text-decoration: underline;\n    }\n  }\n"])));
var CheckedIcon = (0, styled_components_1.default)(CheckedM_1.default)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n  color: ", ";\n  visibility: ", ";\n"], ["\n  color: ", ";\n  visibility: ", ";\n"])), function (p) { return p.theme.oldColors.primary.purple; }, function (props) { return (props.$visible ? "visible" : "hidden"); });
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8;
